import React from 'react';
import { connect } from 'react-redux';

import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';

import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import FilterList from '@material-ui/icons/FilterList';

import ListCommunications from './ListCommunications';
import ListMessages from './ListMessage';
import Filter from './Filter';

class Menu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            search: '',
            nuevasnotificaciones: false,
            filter: {
                from: props.filter ? props.filter.from : '',
                to: props.filter ? props.filter.to : '',
                saved: props.filter ? props.filter.saved : false,
                urgent: props.filter ? props.filter.urgent : false,
                pending: props.filter ? props.filter.pending : false,
                selectedroles: props.filter ? props.filter.selectedroles : undefined,
                selectedusers: props.filter ? props.filter.selectedusers : undefined,
                selectedlocals: props.filter ? props.filter.selectedlocals : undefined,
            },
            showFilter: false,
            someFilter: (props.filter && !!props.filter.from) ||
                (props.filter && !!props.filter.to) ||
                (props.filter && !!props.filter.saved) ||
                (props.filter && !!props.filter.urgent) ||
                (props.filter && !!props.filter.pending) ||
                (props.filter && !!props.filter.selectedlocals) ||
                (props.filter && !!props.filter.selectedusers) ||
                (props.filter && !!props.filter.selectedroles),
        }
        if (props.sent) {
            this.props.loadCommunications(this.state.someFilter, this.state.filter);
        } else {
            this.props.loadMessages(this.state.someFilter, this.state.filter);
        }
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClickSent = (value) => (event) => {
        this.props.history.push(value);
    };

    handleRemoveDate = (nombre) => (event) => {
        this.setState({ [nombre]: '' });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    handleShowFilter = (value) => (event) => {
        this.setState({
            showFilter: value,
        });
    };

    handleApplyFilter = (save, filter) => (event) => {
        const {
            from,
            to,
            saved,
            pending,
            urgent,
            selectedlocals,
            selectedroles,
            selectedusers,
        } = save ? filter : this.state.filter;

        const _filter = {
            from: from,
            to: to,
            pending: pending,
            saved: saved,
            urgent: urgent,
            selectedlocals: selectedlocals,
            selectedroles: selectedroles,
            selectedusers: selectedusers
        };
        const showFilter = !!from ||
            !!to ||
            !!saved ||
            !!urgent ||
            !!pending ||
            !!selectedlocals ||
            !!selectedusers ||
            !!selectedroles;
        this.props.setFilter(_filter ? _filter : {});

        if (this.props.sent) {
            this.props.loadCommunications(showFilter, _filter);
        } else if (!this.props.sent) {
            this.props.loadMessages(showFilter, _filter);
        }

        this.setState({
            showFilter: false,
            someFilter: showFilter,
            filter: _filter,
        });
    };

    render() {
        const { search, showFilter, filter, someFilter } = this.state;
        const { intl, communications_pending } = this.props;
        if (showFilter) {
            return <Filter {...this.props} filter={filter} onClose={this.handleApplyFilter} />;
        }
        return (
            <div className={'flex_full_column  overflow_y_scroll height100'}>
                <div className="flex_auto_row padding_borders_flat align_center">
                    <TextField
                        id="search"
                        name="search"
                        label={intl.formatMessage({ id: 'search' })}
                        className={'flex_full_row margin_right_24'}
                        value={search}
                        onChange={this.handleChange}
                        margin="normal"
                        variant="outlined"
                        classes={{ root: 'communication-search' }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon className="c_disabled" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <FilterList
                        className={
                            'margin_right_12 hand ' + (!someFilter ? 'c_bluish' : 'c_lipstick')
                        }
                        onClick={this.handleShowFilter(true)}
                    />
                </div>
                <div className="flex_auto_row padding_borders_flat align_center border_bottom_gray padding_bottom_24">
                    <div className="flex_auto_row margin_right_32 align_center">
                        <Button
                            onClick={this.handleClickSent('/communications/receive')}
                            className={
                                'button-link barlowsemicondensed_bold ' +
                                (!this.props.sent ? 'c_slate button-link-active ' : 'c_disabled')
                            }
                        >
                            {intl.formatMessage({ id: 'communication_receive' })}
                        </Button>
                        {(communications_pending && communications_pending.mensajes > 0) &&
                            <div className="pendingMessagesCircle">
                                <span className="barlow_regular_smalltext">{communications_pending.mensajes}</span>
                            </div>
                        }
                    </div>
                    <div className="flex_auto_row">
                        <Button
                            onClick={this.handleClickSent('/communications/sent')}
                            className={
                                'button-link barlowsemicondensed_bold ' +
                                (this.props.sent ? 'c_slate button-link-active ' : 'c_disabled')
                            }
                        >
                            {intl.formatMessage({ id: 'communication_sent' })}
                        </Button>
                    </div>
                    {(communications_pending && communications_pending.communiaciones > 0) &&
                        <div className="pendingMessagesCircle">
                            <span className="barlow_regular_smalltext">{communications_pending.communiaciones}</span>
                        </div>
                    }
                </div>
                {this.props.sent && (
                    <div className="flex_full_row overflow_y_scroll height100 list_messages">
                        <ListCommunications {...this.props} search={search} />
                    </div>
                )}
                {!this.props.sent && (
                    <div className="flex_full_row overflow_y_scroll height100 list_messages">
                        <ListMessages {...this.props} search={search} />
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        messages: state.messages,
        messages_is_loading: state.messages_is_loading,
        messages_has_errored: state.messages_has_errored,
        communications_filter: state.communications_filter,
        communications: state.communications,
        communications_is_loading: state.communications_is_loading,
        communications_has_errored: state.communications_has_errored,
        communications_pending: state.communications_pending
    };
}

export default connect(
    mapStateToProps,
    undefined,
)(Menu);


// WEBPACK FOOTER //
// ./src/components/complex/communications/Menu.js